'use client'

import { PropsWithChildren } from 'react'

import { Spinner } from '@/shared/ui'

import { useBridge } from './provider'

export const BridgeLoader = ({ children }: PropsWithChildren) => {
  const { bridge } = useBridge()

  if (!bridge) {
    return <Spinner />
  }

  return children
}
